import { render, staticRenderFns } from "./message-tools.vue?vue&type=template&id=25064982"
import script from "./message-tools.vue?vue&type=script&lang=js"
export * from "./message-tools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25064982')) {
      api.createRecord('25064982', component.options)
    } else {
      api.reload('25064982', component.options)
    }
    module.hot.accept("./message-tools.vue?vue&type=template&id=25064982", function () {
      api.rerender('25064982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/message-tools.vue"
export default component.exports